import { Injectable } from '@angular/core';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root'
})
export class ParametroService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  obtenerSegunCodigoParametro(codigo: number, callback: Function){
    const inputParams = {
      entidad: { codigo },
      paginaActual: 1,
      cantidadRegistrosPorPagina: -1
    };
    this.gqlclient.query(
      {
        query: gql`
          query (
            $entidad: parametroInputType
            $paginaActual: Int
            $cantidadRegistrosPorPagina: Int
          ) {
            parametro {
              obtenerSegunCodigoParametro(
                entidad: $entidad
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  tipo_parametro_codigo
                  nombre
                  descripcion
                  activado
                  tipo_parametro_nombre
                  listParametroSucursal {
                    sucursal_codigo
                    valor
                    rut_empresa
                  }
                  parametroEmpresa {
                    empresa_rut
                    valor
                  }
                  es_empresa
                  es_sucursal
                }
              }  
            }
          }  
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache'
      }, (response: any) => {
        const { mensajes, respuesta } = response.data.parametro.obtenerSegunCodigoParametro;
        callback({ mensajes, respuesta });
      }
    )
  }

  obtenerParametrosConFiltro(inputParams: any, callback: Function){
    this.gqlclient.query(
      {
        query: gql`
          query (
            $empresa_rut: Decimal
            $parametro: String
            $estado: Int
            $paginaActual: Int
            $cantidadRegistrosPorPagina: Int
          ) {
            parametro {
              obtenerSegunFiltroParametro(
                filtro: {
                  exacto: {
                    empresa_rut: $empresa_rut
                    parametro: $parametro
                    estado: $estado
                  }
                }
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    tipo_parametro_codigo
                    nombre
                    descripcion
                    activado
                    tipo_parametro_nombre
                  }
                }
              }
            }  
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache'
      }, (response: any) => {
        const { mensajes, respuesta } = response.data.parametro.obtenerSegunFiltroParametro;
        callback({ mensajes, respuesta });
      }
    )
  }

  guardarParametroConEmpresaSucursal(inputParams: any, callback: Function){
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation (
            $entidad: parametroInputType
          ) {
            parametro {
              guardarParametroEmpresaSucursal(
                entidad: $entidad
              ) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  codigo
                  tipo_parametro_codigo
                  nombre
                  descripcion
                  activado
                  tipo_parametro_nombre
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache'
      }, (response: any) => {
        const { mensajes, respuesta } = response.data.parametro.guardarParametroEmpresaSucursal;
        callback({ mensajes, respuesta });
      }
    )
  }

  editarParametroConEmpresaSucursal(inputParams: any, callback: Function){
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation (
            $entidad: parametroInputType
          ) {
            parametro {
              editarParametroEmpresaSucursal(
                entidad: $entidad
              ) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  codigo
                  tipo_parametro_codigo
                  nombre
                  descripcion
                  activado
                  tipo_parametro_nombre
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache'
      }, (response: any) => {
        const { mensajes, respuesta } = response.data.parametro.editarParametroEmpresaSucursal;
        callback({ mensajes, respuesta });
      });
  }

  cambiarEstadoParametro(codigo: number, callback: Function){
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation (
            $codigo: Decimal
          ) {
            parametro {
              cambiarEstadoParametro(
                codigo: $codigo
              ) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  codigo
                  tipo_parametro_codigo
                  nombre
                  descripcion
                  activado
                  tipo_parametro_nombre
                }
              }
            }
          }
        `,
        variables: { codigo },
        fetchPolicy: 'no-cache'
      }, (response: any) => {
        const { mensajes, respuesta } = response.data.parametro.cambiarEstadoParametro;
        callback({ mensajes, respuesta });
      }
    )
  }
}
